import { Capacitor } from '@capacitor/core';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { ensureAndroidD3Directories } from '@/capacitor/permissions/android-storage-permission';

export const createFile = async (): Promise<void> => {
  try {
    //若目录已存在，视为成功
    const ensureDir = async (path: string, directory: Directory) => {
      try {
        // 如果能读取目录，则已存在
        await Filesystem.readdir({ path, directory });
        return;
      } catch (_) {
        // 不存在则尝试创建
        try {
          await Filesystem.mkdir({ path, directory, recursive: true });
          return;
        } catch (e: any) {
          const msg = (e?.message || '').toLowerCase();
          const code = (e?.code || '').toString();
          // Capacitor Android 插件在目录存在时可能抛出“already exists”/ OS-PLUG-FILE-0010
          if (msg.includes('already exists') || code === 'OS-PLUG-FILE-0010') {
            return; // 目录已存在，成功
          }
          throw e;
        }
      }
    };
    if (Capacitor.getPlatform() === 'android') {
      // Android 11+：Capacitor Directory.ExternalStorage 不可用，改走原生 File API
      const ready = await ensureAndroidD3Directories();
      if (!ready) {
        throw new Error('原生创建 Download/d3 目录失败，请确认已授予存储权限');
      }
    } else if (Capacitor.getPlatform() === 'ios') {
      // iOS - 使用 Documents 目录（用户可以通过文件 App 看到）
      console.log('开始创建 iOS 目录...')
      const documentsPath = await Filesystem.getUri({
        path: '',
        directory: Directory.Documents
      });
      console.log('Documents 目录路径:', documentsPath.uri);
      await ensureDir('d3', Directory.Documents);
      await ensureDir('d3/assets', Directory.Documents);
      await ensureDir('d3/upgrade', Directory.Documents);
      await ensureDir('d3/logs', Directory.Documents);
    }
  } catch (error) {
    console.error('权限验证或目录创建失败（非已存在错误）:', error);
    throw error;
  }
};
